export default [
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'ATMs give',
    },
    cell: {
      type: 'slot',
      name: 'atmsGive',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'ATMs get',
    },
    cell: {
      type: 'slot',
      name: 'atmsGet',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Renter',
    },
    cell: {
      type: 'slot',
      name: 'renter',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Quantity with such conditions',
    },
    cell: {
      type: 'slot',
      name: 'withConditions',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Fees and limits',
    },
    cell: {
      type: 'slot',
      name: 'feesAndLimits',
    },
  },
];
